import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';

const Footer = () => {
    return (
        <div class="container footer">
          <footer class="py-3 mt-4">
            <div class="text-center footer-brand"><a class="navbar-brand" href="/">R&N</a></div> 
            <ul class="nav justify-content-center pb-2 mb-1">
              <li class="nav-item"><a href="/" class="nav-link px-2">Home</a></li>
              <li class="nav-item"><a href="/about" class="nav-link px-2">About Us</a></li>
              <li class="nav-item"><a href="/venue" class="nav-link px-2">Venue</a></li>
              <li class="nav-item"><a href="/accommodation" class="nav-link px-2">Accommodation</a></li>
              <li class="nav-item"><a href="/faq" class="nav-link px-2">FAQs</a></li>
              <li class="nav-item"><a href="/rsvp" class="nav-link px-2">RSVP</a></li>      
            </ul>
            <p class="text-center">&copy; 2024 R&N, Inc</p>
          </footer>
        </div>
        
    );
    }

    export default Footer;
